// OTPHandler.js
const apiUrl = 'https://gnogztrnq1.execute-api.ap-southeast-2.amazonaws.com/dev';
import { validatePhoneNumber, normalizePhoneNumber } from './phoneValidation';

export async function handleOTPSubmission(phone, otpInput) {
    try {
        const normalizedPhone = normalizePhoneNumber(phone);
        console.log('Attempting OTP verification for phone:', normalizedPhone);
        
        const payload = {
            phone: normalizedPhone,
            otp: otpInput
        };
        console.log('Sending verification payload:', payload);

        const response = await fetch(`${apiUrl}/verify-otp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(payload)
        });

        const result = await response.json();
        console.log('Verification response:', result);

        if (!response.ok) {
            throw new Error(result.error || 'Invalid OTP');
        }

        return true;
    } catch (error) {
        console.error('Error verifying OTP:', error);
        // Check if it's an expired OTP
        if (error.message && error.message.toLowerCase().includes('expired')) {
            throw new Error('EXPIRED_OTP');
        }
        throw error;
    }
}

// Add function to check OTP status
export async function checkOTPStatus(phone) {
    try {
        const response = await fetch(`${apiUrl}/check-otp-status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                phone: normalizePhoneNumber(phone)
            })
        });

        return await response.json();
    } catch (error) {
        console.error('Error checking OTP status:', error);
        return { status: 'error' };
    }
}

export async function requestOTP(phone) {
    try {
        const normalizedPhone = normalizePhoneNumber(phone);
        console.log('Requesting OTP for normalized phone:', normalizedPhone);
        
        const response = await fetch(`${apiUrl}/request-otp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({ phone: normalizedPhone })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to send OTP');
        }

        const result = await response.json();
        console.log('OTP request response:', result);
        return result;
    } catch (error) {
        console.error('Error requesting OTP:', error);
        throw error;
    }
}

// Initialize event listeners for OTP functionality
export function initializeOTPHandlers() {
    const resendButton = document.getElementById('resend-otp');
    if (resendButton) {
        resendButton.addEventListener('click', async () => {
            const phone = document.getElementById('phone').value;
            try {
                await requestOTP(phone);
            } catch (error) {
                console.error('Error resending OTP:', error);
            }
        });
    }

    // Prevent form submission until OTP is verified
    const form = document.getElementById('access-form');
    const submitBtn = form?.querySelector('button[type="submit"]');
    if (submitBtn) {
        submitBtn.addEventListener('click', (e) => {
            const otpSection = document.getElementById('otp-section');
            if (!otpSection.classList.contains('hidden') && !document.getElementById('otp-input').value) {
                e.preventDefault();
                alert('Please enter the verification code sent to your phone.');
            }
        });
    }
}